'use client';
import { jsx } from 'react/jsx-runtime';
import t from 'prop-types';
import { useEffect } from 'react';
import { useTabsContext } from './tabs.context.js';
import { renderWithRef } from '../core/render-with-ref.js';
import { useId } from '../../hooks/use-id.js';
import { RenderComp } from '../core/render-comp.component.js';

function _define_property(e, r, t) {
    return r in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function _object_spread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {}, o = Object.keys(t);
        "function" == typeof Object.getOwnPropertySymbols && (o = o.concat(Object.getOwnPropertySymbols(t).filter(function(e) {
            return Object.getOwnPropertyDescriptor(t, e).enumerable;
        }))), o.forEach(function(r) {
            _define_property(e, r, t[r]);
        });
    }
    return e;
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        t.push.apply(t, o);
    }
    return t;
}
function _object_spread_props(e, r) {
    return r = null != r ? r : {}, Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(r)) : ownKeys(Object(r)).forEach(function(t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(r, t));
    }), e;
}
let i = {
    tabId: t.string.isRequired
}, s = Object.keys(i);
const TabContent = renderWithRef('TabContent', i, (r, n)=>{
    let { children: i, tabId: a, id: b } = r, { selectedTabId: f, labelIds: l, registerContent: y, unregisterContent: u } = useTabsContext(), O = useId(b);
    useEffect(()=>(y(a, O), ()=>u(a)), [
        a,
        O,
        y,
        u
    ]);
    let m = new Set([]);
    return a === f && m.add('swan-tab-selected'), jsx(RenderComp, {
        root: "div",
        forwardedRef: n,
        propKeysToRemove: s,
        classNames: m,
        props: _object_spread_props(_object_spread({}, r), {
            id: O,
            role: 'tabpanel',
            'aria-labelledby': l[a]
        }),
        children: i
    });
});

export { TabContent };
